import {ApplicationProviderListModel} from '@app/views/admin/application-settings/models/application-provider-list.model';

export class MasterFieldsModel {
    constructor(
        public dataSourceModelList: ApplicationProviderListModel[] = <ApplicationProviderListModel[]>[],
        public mergingMetadataModelList: MasterFieldsMergingMetadataModel[] = <MasterFieldsMergingMetadataModel[]>[],
        public mergingRuleList: MasterFieldsMergingRule[] = <MasterFieldsMergingRule[]>[]
    ) { }
}

export class EntityMasterFieldsModel {
    constructor(
        public entityName: string,
        public mergingMetadataModelList: MasterFieldsMergingMetadataModel[] = [],
        public mergingRuleList: MasterFieldsMergingRule[] = []
    ) {}
}

export class MasterFieldsMergingMetadataModel {
    constructor(
        public entitySourceDname?: string,
        public friendlyName?: string,
        public propertyName?: string
    ) { }
}

export class MasterFieldsMergingRule {
    public mergingRuleIndex: number;

    constructor(
        public entityTypeDenom: string,
        public propertyName?: string,
        public dataSourceDname?: string,
        public mode?: MergeMode,
        public mergingRuleId?: MasterFieldsMergingRuleId
    ) { }
}

export class MasterFieldsMergingRuleId {
    constructor(
        public ruleId: string
    ) { }
}

export enum MergeMode {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE'
}

export interface IMode {
    value: MergeMode;
    friendlyName: string;
}
